import React from "react";
import "./ProductsPage.css"; // 👈 import the CSS file

const products = [
  {
    id: 1,
    name: "ToxBoxAI",
    description: `ToxBoxAI is an AI-driven platform designed to revolutionize inbound and outbound calling. 
It offers intelligent call routing, real-time transcription...`,
    image: "https://imgs.search.brave.com/f32Z7g-hzS97lf1Uo3M-rWCj_0XOiMZQI_zu4EPr-74/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/cHJlbWl1bS1waG90/by9mdXR1cmlzdGlj/LWNhbGwtY2VudGVy/LWh5YnJpZC1yb2Jv/dC1vcGVyYXRvcnMt/YXNzaXN0aW5nLWN1/c3RvbWVyc182NDE4/NzgtMTUyMC5qcGc_/c2VtdD1haXNfaHli/cmlkJnc9NzQw",
    link: "https://toxboxai.com",
  },
  {
    id: 2,
    name: "ProHireY",
    description: `ProHireY is an AI-powered recruitment solution crafted to streamline hiring processes. 
From sourcing candidates to automated interviews...`,
    image: "https://imgs.search.brave.com/xiOQ27zw9sBY0ZuCiC-45KB5zYSDHN7Q_fAkU4IzUx0/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/ZnJlZS1waG90by9z/Y2VuZS13aXRoLWJ1/c2luZXNzLXBlcnNv/bi13b3JraW5nLWZ1/dHVyaXN0aWMtb2Zm/aWNlLWpvYl8yMy0y/MTUxMDAzNzA1Lmpw/Zz9zZW10PWFpc19o/eWJyaWQmdz03NDA",
    link: "https://prohirey.com/",
  },
];

const ProductsPage = () => {
  return (
    <div className="products-page">
      <h1 className="products-heading">Our Products</h1>
      <div className="products-grid">
        {products.map((product) => (
          <div key={product.id} className="product-card">
            <img src={product.image} alt={product.name} className="product-image" />
            <div className="product-content">
              <h2 className="product-title">{product.name}</h2>
              <p className="product-description">{product.description}</p>
              <a
                href={product.link}
                className="product-button"
                target="_blank"
           
              >
                Click Here
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductsPage;
